import { useDeleteGlobalNotificationMutation, useGlobalNotificationsQuery } from "queries";
import { useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { IGlobalNotification } from "services/types";
import { IAppState } from "store/app-state";
import { InfoBar } from "./InfoBar";
import { metrics } from "utils/metrics";

interface IInfoBarContainer {}

export const InfoBarContainer: React.FC<IInfoBarContainer> = () => {
  const currentUserName = useSelector((state: IAppState) => state.user.currentUser?.username);
  const location = useLocation();
  const [notification, setNotification] = useState<IGlobalNotification | null>(null);
  const [showNotify, setShowNotify] = useState<boolean>(true);
  const { isSuccess, data, isError } = useGlobalNotificationsQuery(currentUserName);
  const deleteGlobalNotification = useDeleteGlobalNotificationMutation(currentUserName);
  const isIfrUrl = useMemo(() => location.pathname.startsWith("/ifr"), [location]);

  useEffect(() => {
    if (isSuccess && data) {
      setNotification(data.global[0]);
    }
  }, [isSuccess, data,]);

  const sendDeleteNotification = async (id: string) => {
    try {
      await deleteGlobalNotification.mutateAsync(id);
    } catch (err) {
      console.error(err);
    }
  };

  const onLinkAction = async (id: string) => {
    await metrics.sendInfobarCta();
    await sendDeleteNotification(id);
    setShowNotify(false);
  };

  const onCloseInfoBar = async (id: string) => {
    setShowNotify(false);
    await metrics.sendInfobarDismiss();
    await sendDeleteNotification(id);
  };

  if (!notification || isIfrUrl || isError) {
    return null;
  }

  return (
    <InfoBar
      showNotify={showNotify}
      onLinkAction={onLinkAction}
      onCloseInfoBar={onCloseInfoBar}
      notification={notification}
    />
  );
};

export default InfoBarContainer;
